import { StudyGroupsApi, NotificationsApi, ToCApi, CoursesApi, UsersApi, ParticipantsApi, SubmissionsApi, SubmissionStatisticsApi, ApiClient, MessagesApi, GeneralApi, LessonsApi, AssessmentsApi, ProjectsApi, PostsApi, ContentBankApi, MessageTypeApi, TrainingsApi, ApplicationsApi, LessonParticipantsApi, LocksApi } from '@skillz/lms.api.client'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { ObjectTypeEnum, ObjectTypeNamesEnum } from './models/ObjectTypeEnum';

function getUrl(cmd) {
    // return `${window.config.apiUrl}/api/${cmd}`
    return `${window.config.LMSApiUrl}/${cmd}`
}

export async function getJson(cmd) {
    let url = getUrl(cmd)
    let response = await fetch(
        url, {
        mode: 'cors',
        credentials: "include"
    });
    if (response.status === 200) {
        let res = await response.json()
        console.log("getJson res", res);
        return res;
    }
    else if (response.status === 401) {
        return { status: 401 }
    }
    throw `status from api ${response.status}`;
}

export async function putJson(cmd, data) {

    let url = getUrl(cmd)
    let response = await fetch(
        url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        mode: 'cors',
        credentials: "include",
        body: JSON.stringify(data)
    });
    if (response.status === 200) {
        return response;
    } else if (response.status === 401) {

    }
    // window.location.href = "/portal/login?next=/portal/"
}

export async function postJson(cmd, data, baseUrl) {
    let url = baseUrl ? `${baseUrl}${cmd}` : getUrl(cmd)
    // alert(url)
    let response = await fetch(
        url, {
        method: 'POST',
        mode: 'cors',
        credentials: "include",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });

    if (response.ok)
        return response;
    throw response.status
}

export function exportXlsx(filename, headerNames, arr, withColors, dontReplaceRow) {
    const workBook = new Workbook();
    const workSheet = workBook.addWorksheet(filename.replace(/[`*\?:\\[\]\\\/]/gi, ''));
    workSheet.addRows([[filename], ...headerNames]);
    arr.forEach(item => {
        let itemValuesArr = Object.values(item);
        if (!dontReplaceRow) {
            itemValuesArr.unshift(itemValuesArr[itemValuesArr.length - 1])
            itemValuesArr.pop()
        }
        const row = workSheet.addRow(itemValuesArr);
        if (withColors) {
            // for (let i = 1; i < itemValuesArr.length; i++) {
            //     const col = row.getCell(i + 1);
            //     if (itemValuesArr[i]) {
            //         const currentAssessment = studentsScores.find(ss => ss.id === item.userId).assessments[0];
            //         const x = levelColor(currentAssessment.submission?.score * (currentAssessment.maxScore ? currentAssessment.maxScore - currentAssessment.minScore : 100), currentAssessment.submission?.submissionStatusId)
            //         col.fill = {
            //             type: 'pattern',
            //             pattern: 'solid',
            //             fgColor: { argb: x.minScore > 0 ? '1c9471' : 'e63e3e' }
            //         };
            //     }
            // }
        }
    });
    workBook.xlsx.writeBuffer().then(data => {
        let blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        saveAs(blob, `${filename}.xlsx`);
    })
}

const apiClient = new ApiClient(`${window.config.LMSApiUrl}`);
export const submissionsApi = new SubmissionsApi(apiClient)
export const submissionStatisticApi = new SubmissionStatisticsApi(apiClient)
export const participantsApi = new ParticipantsApi(apiClient)
export const projectsApi = new ProjectsApi(apiClient)
export const usersApi = new UsersApi(apiClient)
export const locksApi = new LocksApi(apiClient)
export const coursesApi = new CoursesApi(apiClient)
export const studyGroupsApi = new StudyGroupsApi(apiClient)
export const notificationsApi = new NotificationsApi(apiClient)
export const toCApi = new ToCApi(apiClient)
export const messagesApi = new MessagesApi(apiClient)
export const generalApi = new GeneralApi(apiClient)
export const lessonsApi = new LessonsApi(apiClient)
export const ApplicationApi = new ApplicationsApi(apiClient)
export const assessmentsApi = new AssessmentsApi(apiClient)
export const postsApi = new PostsApi(apiClient)
export const contentBankApi = new ContentBankApi(apiClient)
export const messageTypeApi = new MessageTypeApi(apiClient)
export const trainingsApi = new TrainingsApi(apiClient)
export const lessonParticipantsApi = new LessonParticipantsApi(apiClient)
export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export function getClassByNum(num) {
    let lang = localStorage.getItem("LANG");
    switch (lang) {
        case 'en':
            return ["1st", "2nd", "3rd", "4th", "5th", "6th", "7th", "8th", "9th", "10th", "11th", "12th"][num - 1];
        default:
            return ["א", "ב", "ג", "ד", "ה", "ו", "ז", "ח", "ט", "י", "יא", "יב"][num - 1];
    }

}


export function getKeyByValue(val, object) {
    const filter = Object.keys(object).filter(key => object[key] == val);
    if (filter && filter.length > 0)
        return filter[0];
    return null;
}

export function getMaxValue(array, field) {
    return array?.reduce((max, obj) => (obj[field] > max ? obj[field] : max), array[0][field])
}

export const sendMessageToServiceWorker = (action, data) => {

};


export async function notCachefetchJson(url) {
    try {
        let notCacheNumber = Math.floor(new Date().getTime());
        let res = await fetch(`${url}?ver=${notCacheNumber}`)

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        }
        else {
            throw new Error(`faild to fetch json url: ${url} with status: ${res && res.status}`)
        }
    }
    catch (err) {
        console.log("error in fetch json", url, err);
    }
}

export const getObjectTypeName = (type) => {
    const entry = Object.entries(ObjectTypeEnum).find(([key, value]) => value === type);
    return entry ? ObjectTypeNamesEnum[entry[0]] : null;
}